import clsx from "clsx";
import React from "react";
import { Grid2Props } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import {
  ComponentTemplatePrivacyType,
  ComponentTemplateSort,
} from "@growth-machine-llc/stridist-api-client";
import { LibraryHeaderFilters } from "../header-filters/HeaderFilters";
import { HeaderSelect } from "../header-filters/HeaderSelect";
import { ComponentTemplatePrivacyTypeLabels } from "./constants";
import { JourneyAnchors } from "../../constants";

const useStyles = makeStyles((theme) => ({
  inputActive: {
    "&.MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },

    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
  },

  sort: {
    backgroundColor: theme.palette.background.paper,
    fontWeight: 500,
    [theme.breakpoints.up("md")]: {
      maxWidth: 400,
    },
    '& [aria-haspopup="listbox"]': {
      color: theme.palette.text.secondary,

      "&::before": {
        content: '"Filter by type: "',
      },
    },
  },

  sortOption: {
    fontWeight: 500,
  },
}));

export interface CoachComponentTemplateLibraryHeaderFiltersProps
  extends Grid2Props {
  query: string;
  sortKey: ComponentTemplateSort;
  onChangeQuery?: (query: string) => void;
  onChangeSortKey?: (sortKey: ComponentTemplateSort) => void;
  templatePrivacyType?: ComponentTemplatePrivacyType;
  onChangeTemplatePrivacyType?: (
    templatePrivacyType: ComponentTemplatePrivacyType,
  ) => void;
  defaultValues: {
    query: string;
    sortKey: ComponentTemplateSort;
  };
}

export function CoachComponentTemplateLibraryHeaderFilters(
  props: CoachComponentTemplateLibraryHeaderFiltersProps,
) {
  const s = useStyles();
  const {
    className,
    query,
    onChangeQuery,
    templatePrivacyType,
    onChangeTemplatePrivacyType,
    defaultValues: { query: defaultQuery },
  } = props;

  const handleChangeTemplatePrivacyType = React.useCallback(
    (event) => {
      const templatePrivacyType = event.target
        .value as ComponentTemplatePrivacyType;
      if (onChangeTemplatePrivacyType) {
        onChangeTemplatePrivacyType(templatePrivacyType);
      }
    },
    [onChangeTemplatePrivacyType],
  );

  return (
    <>
      <LibraryHeaderFilters
        query={query}
        onChangeQuery={onChangeQuery}
        className={className}
        searchPlaceholder={`Search by name`}
        defaultValues={{
          query: defaultQuery,
        }}
        selectItem={
          <>
            <HeaderSelect
              value={templatePrivacyType}
              onChange={handleChangeTemplatePrivacyType}
              options={Object.values(ComponentTemplatePrivacyType)}
              labels={ComponentTemplatePrivacyTypeLabels}
              className={clsx(
                s.sort,
                s.inputActive,
                JourneyAnchors.COMPONENT_TEMPLATE_PRIVACY_FILTER,
              )}
            />
          </>
        }
      />
    </>
  );
}
